import { useIntl } from 'react-intl';

import { IModifierSelections } from 'components/product-detail-v2/modifier/types';
import { MenuObjectTypes } from 'enums/menu';
import {
  ProductWizardStep,
  SingleOrMultipleModifierSelection,
} from 'state/product-wizard-v2/types';

import { getSingleOrMultipleChoiceCtaBtnProps } from '../utils';

interface IGetProductAddToCartCtaLabelProps {
  // Product state
  maxCartQuantityMet: boolean;
  isEditingCartEntry: boolean;
  type: MenuObjectTypes;

  // Modifier state
  selections: IModifierSelections;
  singleOrMultipleModifierSelection: SingleOrMultipleModifierSelection | null;

  // Wizard state
  currentStep?: ProductWizardStep;
  slotKeyToCustomize?: string;

  // UI state
  disableCta?: boolean;
  formattedProductPrice: string;
}

interface IGetProductAddToCartCtaLabelReturnProps {
  disabled: boolean;
  buttonLabel: string;
}

export const useGetProductAddToCartCtaLabel = ({
  currentStep,
  disableCta,
  formattedProductPrice,
  isEditingCartEntry,
  maxCartQuantityMet,
  selections,
  singleOrMultipleModifierSelection,
  type,
}: IGetProductAddToCartCtaLabelProps): IGetProductAddToCartCtaLabelReturnProps => {
  const { formatMessage } = useIntl();

  const getAddToOrderText = () =>
    formatMessage({
      id: isEditingCartEntry ? 'update' : 'addToCart',
    });

  if (disableCta) {
    return {
      disabled: disableCta,
      buttonLabel: formatMessage({ id: 'pleaseSelect' }) ?? getAddToOrderText(),
    };
  }

  // Disable the CTA until modifier selections have been made
  const { disabled, label } = getSingleOrMultipleChoiceCtaBtnProps({
    currentStep,
    formatMessage,
    selections,
    singleOrMultipleModifierSelection,
    type,
  });

  const getButtonLabel = () => {
    if (maxCartQuantityMet) {
      return formatMessage({ id: 'limitReached' });
    }

    if (disabled) {
      return label;
    }

    return `${getAddToOrderText()} - ${formattedProductPrice}`;
  };

  return {
    disabled,
    buttonLabel: getButtonLabel(),
  };
};
